import { createFileRoute } from "@tanstack/react-router";
import { PlaceholderPage } from "../../../components/layouts/PlaceholderPage";
import { requireModuleAccess, MODULE_SITE_MANAGEMENT } from "../../../lib/auth/route-protection";
import { useI18n } from "../../../lib/i18n";

function SiteOverviewPage() {
  const { t } = useI18n();
  return <PlaceholderPage title={t("pro.site.overviewTitle")} />;
}

export const Route = createFileRoute("/site/overview/")({
  beforeLoad: requireModuleAccess(MODULE_SITE_MANAGEMENT),
  component: SiteOverviewPage,
});
